import Image1 from "../Assets/Blockchain.png";
import Image2 from "../Assets/Homelyhub.png";
import Image3 from "../Assets/WeatherApp.png";
// import Image4 from "../Assets/WeatherApp.png";
import Image5 from "../Assets/QuizApp.png";
import Image6 from "../Assets/TextUtils.png";

export const ProjectData = [
    {
      id: 1,
      image: Image1,
      title: "Marks Uploading System using Blockchain",
      description:
        "The Marks Uploading System, utilizing blockchain and ThirdWeb technology, securely manages academic records, especially student marks. It provides user-friendly interfaces, automation through smart contracts, data privacy via encryption, and transparency through immutable audit trails. Integration with existing systems, scalability, and compliance with data protection regulations are key components, making it a dependable solution for educational institutions.",
    },
    {
      id: 2,
      image: Image2,
      title: "Homelyhub A hotel booking website",
      description:
        "Homely Hub is a hotel booking website created with the MERN stack, offering users a simple and efficient platform to find and book accommodations. With real-time availability, detailed listings, secure payments, and user reviews, it provides a seamless experience for both guests and hosts. The site's intuitive design and modern technology aim to streamline the hotel booking process for all users. really good job, all aspects of the project were followed step by step and with good results.",
    },
    {
      id: 3,
      image: Image3,
      title: "Weather App",
      description:
        "The Weather App is a web application developed using React.js, designed to provide users with up-to-date weather information. With a clean and intuitive interface, users can easily search for weather conditions in their desired locations. The app fetches data from a weather API and displays current weather conditions, temperature, humidity, wind speed, and more. Users can also view forecasts for the upcoming days, ensuring they are prepared for any weather changes.",
    },
    {
      id: 4,
    //   image: Image4,
      title: "News App",
      description:
        "A The News App is a user-friendly application developed with React.js, providing a seamless platform for users to stay updated with the latest news. With its intuitive interface, users can easily browse through various news categories, read articles, and stay informed about current events. The app offers features such as personalized news feeds, search functionality, and article bookmarking for convenient access to favorite stories. With React.js's fast rendering and responsive design.",
    },
    {
      id: 5,
      image: Image5,
      title: "Quiz App",
      description:
        "The Quiz App built with React.js is a dynamic and engaging platform where users can participate in quizzes on various topics. It features a sleek and user-friendly interface, offering multiple-choice questions, timed quizzes, and instant feedback on answers. Users can track their progress, view leaderboards, and share scores with friends. The app's responsive design ensures compatibility across devices, providing an immersive quiz experience for users of all levels. good job, all aspects of the project were followed step by step and with good results.",
    },
    {
      id: 6,
      image: Image6,
      title: "TextUtils",
      description:
        "A TextUtils is a React.js-based web application designed to provide users with various text manipulation tools. With a clean and intuitive interface, users can easily perform tasks such as text formatting, character counting, converting case, and generating Lorem Ipsum text. The app offers convenience and efficiency for users who need quick and simple text editing solutions. good job, all aspects of the project were followed step by step and with good results.",
    },
  ];
  